// tanstack
import { createFileRoute } from '@tanstack/react-router';

// feature-components
import StandardAnalysisPage from '@/features/energyxplorer/components/deepdive/StandardAnalysisPage';

export const Route = createFileRoute(
  '/$accountId/_user/energyxplorer/portfolio/$analysisType/$energyGroupId/energy-breakdown-table',
)({
  component: StandardAnalysisPage,
});
